export const INVALID_CONVERSATION_DESCRIPTION_TEXT =
	'We could not find the conversation data for this prospect at this time. Please contact support if this problem persists.';

export const CONVERSATION_TAB_MESSAGE_SECTION = 'conversation-tab-message-section';
